import { API_AUTH } from "./common";

const KhoiPhucPhieuBiXoaApi = {
  phanQuyen: () => API_AUTH.get(`phan-quyen-khoi-phuc-phieu-bi-xoa`, {}),
  khoiPhuc: (Id) => API_AUTH.post(`khoi-phuc-phieu-bi-xoa?Id=${Id}`, {}),
  phieuCoTheKhoiPhuc: (ids) => API_AUTH.post(`phieu-co-the-khoi-phuc`, ids),
};

export default KhoiPhucPhieuBiXoaApi;
